module.exports = __webpack_public_path__ + "static/media/AMCNormal.86090e53.svg";